import { Inject, Injectable } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { Http, RequestOptions, Headers } from "@angular/http";

import { Config } from "src/app/config";
import { SERVERRESPONSERESULT } from "src/app/models/serverresponse";
import { ServerResponseBrand } from "src/app/models/serverresponse_brand";

// Reads the host's brand before the app starts (an APP_INITIALIZER), so nothing is drawn in
// another brand's look. Any failure keeps acro's look, so the study still opens. The tab's
// icons are then set to the brand's.
@Injectable()
export class BrandService {
  constructor(private http: Http, @Inject(DOCUMENT) private document: Document) {}

  load(): Promise<void> {
    const headers: Headers = new Headers();
    headers.append("X-Requested-With", "XMLHttpRequest");
    const opts: RequestOptions = new RequestOptions();
    opts.headers = headers;
    const data = {
      opt: "brand",
    };

    return this.http
      .post(Config.SERVER_API, data, opts)
      .toPromise()
      .then(response => {
        const json = <ServerResponseBrand>response.json();
        if (json.result == SERVERRESPONSERESULT.OK && Config.BRANDS[json.brand]) {
          Config.BRAND = json.brand;
          return;
        }
        console.error("The brand answer was not understood; showing acro's look.");
      })
      .catch(error => {
        console.error("The brand could not be read; showing acro's look.", error);
      })
      .then(() => this.setFavicon());
  }

  // index.html links acro's favicon.ico; this replaces every icon link with the brand's files.
  private setFavicon(): void {
    const head = this.document.head;
    const links = head.querySelectorAll('link[rel~="icon"]');
    for (let i = 0; i < links.length; i++) {
      head.removeChild(links[i]);
    }

    const folder = "assets/favicons/" + Config.BRAND + "/";
    const icons = [
      { type: "image/x-icon", sizes: "", file: "favicon.ico" },
      { type: "image/png", sizes: "32x32", file: "favicon-32x32.png" },
      { type: "image/png", sizes: "16x16", file: "favicon-16x16.png" },
    ];
    for (const icon of icons) {
      const link = this.document.createElement("link");
      link.rel = "icon";
      link.type = icon.type;
      if (icon.sizes) {
        link.setAttribute("sizes", icon.sizes);
      }
      link.href = folder + icon.file;
      head.appendChild(link);
    }
  }
}

export function loadBrand(brandService: BrandService): () => Promise<void> {
  return () => brandService.load();
}
